var React = require('react');

function Cloud3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.9217 59H119.83C119.83 59 130.81 58.0963 130.998 47.8399C131.185 37.5835 120.522 31.8307 111.034 36.7342C111.034 36.7342 113.485 27.7864 106.236 21.3916C98.9865 14.9967 90.245 20.8583 90.245 20.8583C90.245 20.8583 96.2143 9.88584 83.5295 2.3207C70.8447 -5.24444 62.9531 7.75258 63.378 13.8264C63.378 13.8264 51.0095 -9.50601 24.9974 4.44901C24.9974 4.44901 9.64415 12.4388 17.427 31.5097C17.427 31.5097 3.48703 28.8728 0.368947 43.4944C-2.74914 58.121 14.9217 59 14.9217 59Z","fill":"white"}));
}

Cloud3.defaultProps = {"width":"131","height":"59","viewBox":"0 0 131 59","fill":"none"};

module.exports = Cloud3;

Cloud3.default = Cloud3;
